import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\MenuController::upload
* @see app/Http/Controllers/Settings/MenuController.php:145
* @route '/admin/marketing/site-menu/{menuItem}/media'
*/
export const upload = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

upload.definition = {
    methods: ["post"],
    url: '/admin/marketing/site-menu/{menuItem}/media',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Settings\MenuController::upload
* @see app/Http/Controllers/Settings/MenuController.php:145
* @route '/admin/marketing/site-menu/{menuItem}/media'
*/
upload.url = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { menuItem: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { menuItem: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            menuItem: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        menuItem: typeof args.menuItem === 'object'
        ? args.menuItem.id
        : args.menuItem,
    }

    return upload.definition.url
            .replace('{menuItem}', parsedArgs.menuItem.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\MenuController::upload
* @see app/Http/Controllers/Settings/MenuController.php:145
* @route '/admin/marketing/site-menu/{menuItem}/media'
*/
upload.post = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::upload
* @see app/Http/Controllers/Settings/MenuController.php:145
* @route '/admin/marketing/site-menu/{menuItem}/media'
*/
const uploadForm = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::upload
* @see app/Http/Controllers/Settings/MenuController.php:145
* @route '/admin/marketing/site-menu/{menuItem}/media'
*/
uploadForm.post = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upload.url(args, options),
    method: 'post',
})

upload.form = uploadForm

/**
* @see \App\Http\Controllers\Settings\MenuController::deleteMethod
* @see app/Http/Controllers/Settings/MenuController.php:206
* @route '/admin/marketing/site-menu/{menuItem}/media/{mediaId}'
*/
export const deleteMethod = (args: { menuItem: string | number | { id: string | number }, mediaId: string | number } | [menuItem: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/admin/marketing/site-menu/{menuItem}/media/{mediaId}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Settings\MenuController::deleteMethod
* @see app/Http/Controllers/Settings/MenuController.php:206
* @route '/admin/marketing/site-menu/{menuItem}/media/{mediaId}'
*/
deleteMethod.url = (args: { menuItem: string | number | { id: string | number }, mediaId: string | number } | [menuItem: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            menuItem: args[0],
            mediaId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        menuItem: typeof args.menuItem === 'object'
        ? args.menuItem.id
        : args.menuItem,
        mediaId: args.mediaId,
    }

    return deleteMethod.definition.url
            .replace('{menuItem}', parsedArgs.menuItem.toString())
            .replace('{mediaId}', parsedArgs.mediaId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\MenuController::deleteMethod
* @see app/Http/Controllers/Settings/MenuController.php:206
* @route '/admin/marketing/site-menu/{menuItem}/media/{mediaId}'
*/
deleteMethod.delete = (args: { menuItem: string | number | { id: string | number }, mediaId: string | number } | [menuItem: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::deleteMethod
* @see app/Http/Controllers/Settings/MenuController.php:206
* @route '/admin/marketing/site-menu/{menuItem}/media/{mediaId}'
*/
const deleteMethodForm = (args: { menuItem: string | number | { id: string | number }, mediaId: string | number } | [menuItem: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::deleteMethod
* @see app/Http/Controllers/Settings/MenuController.php:206
* @route '/admin/marketing/site-menu/{menuItem}/media/{mediaId}'
*/
deleteMethodForm.delete = (args: { menuItem: string | number | { id: string | number }, mediaId: string | number } | [menuItem: string | number | { id: string | number }, mediaId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

const media = {
    upload: Object.assign(upload, upload),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default media